import { WHITE_COLOR, BLACK_COLOR, NATURAL_COLOR } from './../constants';
import { CompleteIntermediateShelf } from './../entities/CompleteIntermediateShelf';
import { Cabinet } from '../entities/Cabinet';
import { Position, PaneMaterial } from '../constants';
import { Shelf } from '../entities/Shelf';

function fixAndUpdate(
  shelf: Shelf,
  interShelf: CompleteIntermediateShelf,
  doubleTap: boolean,
  update: boolean,
) {
  if (!update) {
    console.debug(
      '[Inter. shelf Manager] ERROR doule tap',
      'Shelf ' + shelf.level,
      interShelf.position,
      doubleTap,
    );
    throw new Error(
      'Shelf ' +
        shelf.level +
        ' has bad double tap for inter shelf ' +
        interShelf.position,
    );
  }

  interShelf.updateIntermediateShelf(
    undefined,
    undefined,
    undefined,
    doubleTap,
  );

  console.debug(
    '[Inter. shelf Manager] auto update double tap',
    'Shelf ' + shelf.level,
    interShelf.position,
    doubleTap,
  );
}

function checkAndUpdateIS(shelf: Shelf, update: boolean) {
  if (shelf.intermediatesShelves.length > 0) {
    for (const is of shelf.intermediatesShelves) {
      const needDoubleTap =
        !shelf.firtRackHasPaneForPosition(Position.Back) &&
        (is.interShelf.color.reference === WHITE_COLOR ||
          is.interShelf.color.reference === BLACK_COLOR ||
          is.interShelf.color.reference === NATURAL_COLOR);

      if (is.interShelf.base.doubleTap !== needDoubleTap)
        fixAndUpdate(shelf, is, needDoubleTap, update);
    }
  }
}

export function checkAndUpdateInterShelves(
  cabinet: Cabinet,
  update = true,
): void {
  for (const shelf of cabinet.shelves) checkAndUpdateIS(shelf, update);
}
